<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h12">Back to the Dream</h1>
<p class="p14"><img alt="img7.png" src="Images/img7.png"/></p>
<p class="p12"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008.vue?23c51234